import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import service from "../../apiSection/service";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  tableCellClasses,
  TablePagination,
} from "@mui/material";
import Paper from "@mui/material/Paper";
//import CardLayout from "./CardLayout";
import ActionButton from "./Button";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import sortIcon from "../../assets/images/sort.png";
import _ from "lodash";
import NoListData from "./NoListData";
import TableSkeleton from "./TableSkeleton";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import EditIcon from '@mui/icons-material/Edit';
//import ToggleSwitch from "./Switch";
import { IconButton } from "@mui/material";
import deleteIcon from "../../assets/delete.svg";
import editIcon from "../../assets/edit.svg";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import formatDate from "../../Utils/onlyDateFormat";
import RefreshIcon from "@mui/icons-material/Refresh";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Menu, MenuItem } from "@mui/material";
import ToggleDrawer from "./ToggleDrawer";
const StyledTableCell = styled(TableCell)(() => ({
  height: "auto",
  whiteSpace: "nowrap",
  borderBottom: "1px solid #e9e9e9",
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F5F6F8",
    color: "#1B2559",
    fontSize: "14px",
    height: "auto",
    fontWeight: 600,
    fontFamily: "'Poppins', sans-serif",
    borderTop: "0px solid transparent",
    borderBottom: "0px solid transparent",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "14px",
    color: "#707EAE",
  },
  [`&.${tableCellClasses.root}`]: {
    padding: "10px",
  },
}));
const StyledTableRow = styled(TableRow)(() => ({
  height: "51px",
  "&:nth-of-type(even)": {
    backgroundColor: "transparent",
    // color: "#707EAE"
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    // border: 0,
    // border:"1px solid #EBEBEB",
  },
}));
function CommonTable(props) {
  // const columns = props.colsData;
  const [columns, setColumns] = React.useState(props.colsData);
  const [rows, setRows] = React.useState([]);
  const [paginationData, setPaginationData] = React.useState(() => {
    if (props?.paginationData) {
      return { ...props.paginationData };
    } else {
      return { pageNo: 0, size: 10, search: false, searchVal: "" };
    }
  });
  const [selected, setSelected] = React.useState([]);
  const [listLoading, setListLoading] = React.useState(true);
  const [totalElements, setTotalElements] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [show, setShow] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPaginationData((data) => {
      return { ...data, pageNo: newPage };
    });
    //getList();
  };

  const handleChangeRowsPerPage = (event) => {
    setPaginationData((data) => {
      return { ...data, pageNo: 0, size: +event.target.value };
    });
    // getList();
  };
  const handlePopClick = (event, data) => {
    props.handelTableItemDataPop(event, data);
  };

  if (props?.setIsDownloadRequired) {
    if (!listLoading && _.get(rows, "length", 0) <= 0) {
      props.setIsDownloadRequired(false);
    } else {
      props.setIsDownloadRequired(true);
    }
  }

  const handleClick = (event, row) => {
    const selectedIndex = selected.indexOf(row);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const handleImageError = (e) => {
    e.target.onerror = null; // To prevent infinite recursion if fallback image also fails
    // e.target.src = person;
  };
  const getList = () => {
    if (!props.apiEndpoint) {
      setListLoading(false);
    }
    setListLoading(true);

    let searchInput = document.getElementById("searchInput");
    if (searchInput) {
      searchInput.value = paginationData.searchVal;
    }

    if (props.handleChange) {
      props.handleChange({
        ...paginationData,
        search: paginationData.searchVal ? true : false,
      });
    }

    // pageNo, size
    let request_data = {
      page: paginationData.pageNo + 1,
      per_page: paginationData.size,
    };
    if (
      props.filter_data &&
      _.get(Object.keys(props.filter_data), "length") > 0
    ) {
      Object.keys(props.filter_data).forEach((key) => {
        request_data = { ...request_data, [key]: props.filter_data[key] };
      });
    }
    if (_.has(props, "searchValue"))
      request_data["search_string"] = props.searchValue;
    else if (_.has(props, "category"))
      request_data["category"] = props.category;
    service
      .create(props.apiEndpoint, request_data)
      .then((response) => {
        // if (props.setDashboardData) {
        //   props.setDashboardData(response.data.result);
        // }
        if (props.setCustomFilter) {
          props.setCustomFilter(request_data);
        }
        if (_.get(response, "data.list.length", 0) > 0) {
          setRows(response["data"]["list"]);
          if (props.setTableData) {
            props.setTableData(response["data"]["list"]);
          }
        } else if (_.get(response, "data.result.list.length", 0) > 0) {
          setRows(response["data"]["result"]["list"]);
          if (props.setTableData) {
            props.setTableData(response["data"]["result"]["list"]);
          }
        } else {
          setRows([]);
          if (props.setTableData) {
            props.setTableData([]);
          }
        }
        if (_.get(response, "data.total_count") > 0)
          setTotalElements(response["data"]["total_count"]);
        else if (_.get(response, "data.result.total_count", 0) > 0)
          setTotalElements(response["data"]["result"]["total_count"]);
        else setTotalElements(0);
        setListLoading(false);
      })
      .catch(() => {
        setRows([]);
        if (props.setTableData) {
          props.setTableData([]);
        }
        setListLoading(false);
      });
  };

  React.useEffect(() => {
    getList();
  }, [props.filter_data, paginationData, props.render]);

  const handleView = (data, key) => {
    props.getRowData(data, key);
  };
  const [menuOpenItemId, setMenuOpenItemId] = React.useState(null);
  const handleToggleMenu = (id = null) => {
    setMenuOpenItemId(id);
  };
  const handleSorting = (col) => {
    const newSortOrder = col.sortOrder === "asc" ? "desc" : "asc";
    let sortedData = dynamicSort(rows, col.id, newSortOrder);

    setRows([...sortedData]);

    const updatedColumns = columns.map((column) =>
      column.id === col.id ? { ...column, sortOrder: newSortOrder } : column
    );

    setColumns(updatedColumns);
  };
  // Sorting function
  function dynamicSort(dataArray, columnKey, sortOrder) {
    return dataArray.sort((a, b) => {
      // If value is a string, compare case-insensitively
      let valA =
        typeof a[columnKey] === "string"
          ? a[columnKey].toLowerCase()
          : a[columnKey];
      let valB =
        typeof b[columnKey] === "string"
          ? b[columnKey].toLowerCase()
          : b[columnKey];

      // Compare based on ascending or descending order
      if (sortOrder === "asc") {
        return valA > valB ? 1 : valA < valB ? -1 : 0;
      } else {
        return valA < valB ? 1 : valA > valB ? -1 : 0;
      }
    });
  }
  const handleToggle = (event, user_id) => {
    setShow(true);
    setMenuOpenItemId(user_id);
    if (event && user_id) {
      setAnchorEl(event.currentTarget); // Set the clicked button element
      setMenuOpenItemId(user_id); // Set the row ID
    } else {
      setAnchorEl(null); // Reset on close
      setMenuOpenItemId(null);
    }
  };
  const handleEdit = (row) => {
    let user_id = row.user_id;
    props.setOpen(true);

    props.setUserId(user_id);
    setShow(false);
  };

  const handleDelete = (data) => {
    props.getRowId(data);
    setShow(false);
  };
  const overdueReasign = (row) => {
    if ([2, 3].indexOf(row.status_id) > -1) {
      return false;
    }

    let createdOn = row.created_on;
    let host = window.location.host;
    const currentTime = new Date();
    const createdTime = new Date(createdOn);
    const diffInHours = (currentTime - createdTime) / (1000 * 60 * 60);
    if (
      [
        "test-ticketing.machint.com",
        "dev-ticketing.machint.com",
        "localhost:3000",
      ].indexOf(host) > -1
    ) {
      const diffInMilliseconds = currentTime - createdTime;
      const diffInMinutes = diffInMilliseconds / (1000 * 60);
      return diffInMinutes > 10;

      return diffInHours > 48;
    }
  };
  return (
    <div onMouseLeave={() => handleToggleMenu(-1)}>
      {props.hideSearch ? (
        ""
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: "22px",
          }}
        >
          {/* <div style={{ position: "relative" }}>
               
                <Input
                id="searchInput"
                  placeholder="Search..."
                  name="search"
                  shrink={true}
                  watch={props.watch}
                  widht="fit-content"
                  handleChange={handleChangeSearch}
                  paddingLeft="20px"
                />
                <img
                  src={search}
                  style={{ position: "absolute", top: "14px", left: "10px" }}
                />
              </div> */}
          {/* <div>
                <img src={FilterIcon} />
              </div> */}
        </div>
      )}

      {listLoading ? (
        <TableSkeleton
          rows={6}
          columns={_.get(props, "colsData.length", 4)}
          colsData={props.colsData}
        ></TableSkeleton>
      ) : !listLoading && _.get(rows, "length", 0) <= 0 ? (
        <NoListData message={props.noDataMessage || "No data found"} />
      ) : (
        <></>
      )}

      {!listLoading && _.get(rows, "length", 0) > 0 && (
        <>
          <TableContainer
            component={Paper}
            style={{
              width: "100%",

              boxShadow: "0 0 0 0",
              border: "solid 1px #e9e9e9",
            }}
            sx={{ maxHeight: 440 }}
          >
            <Table stickyHeader aria-label="sticky table" style={{ ...props }}>
              {props.additionalHeader && (
                <TableHead>
                  <TableRow
                  // initialState={{ pinnedColumns: { right: ["actions"] } }}
                  >
                    {columns.map((column, index) => (
                      <StyledTableCell key={index}>
                        {column.topLabel}{" "}
                        {props.sorting ? <KeyboardArrowUpIcon /> : null}
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
              )}
              <TableHead>
                <TableRow
                  initialState={{ pinnedColumns: { right: ["actions"] } }}
                >
                  {columns.map((column, index) => (
                    <StyledTableCell key={index}>
                      {column.isSorting && (
                        <span
                          onClick={() => {
                            handleSorting(column);
                          }}
                        >
                          <img
                            src={sortIcon}
                            alt="sortIcon"
                            style={{ cursor: "pointer" }}
                          />
                        </span>
                      )}{" "}
                      &nbsp;
                      {column.label}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows && rows.length > 0
                  ? rows.map((row, index) => {
                      return (
                        <StyledTableRow
                          key={row.name}
                          onClick={(event) => handleClick(event, row)}
                        >
                          {columns.map((column) => {
                            let value = "";
                            switch (column.id) {
                              case "sNo":
                                value =
                                  paginationData.size * paginationData.pageNo +
                                  index +
                                  1;
                                break;
                              case "tckt_id":
                                value = (
                                  <div
                                    style={{
                                      color:
                                        row.tckt_status === 3 ||
                                        row.tckt_status === 2
                                          ? "rgb(0, 123, 255)"
                                          : row.tckt_status === 5 ||
                                            row.tckt_status === 9 ||
                                            overdueReasign(row)
                                          ? "#FF4646"
                                          : row.tckt_status === 3
                                          ? "#007bff"
                                          : overdueReasign(row)
                                          ? "rgb(0, 123, 255)"
                                          : "#007bff",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() => handleView(row, "details")}
                                  >
                                    {row[column.id]}
                                  </div>
                                );
                                break;
                              case "dccb_code":
                              case "pac_id":
                              case "district":
                              case "department_desc":
                              case "intellect_ticket_no":
                              case "severity_desc":
                              case "created_on":
                                value = (
                                  <div
                                    style={{
                                      color:
                                        row.tckt_status !== undefined &&
                                        (row.tckt_status === 3 ||
                                          row.tckt_status === 2)
                                          ? "#707EAE"
                                          : row.tckt_status !== undefined &&
                                            (row.tckt_status === 5 ||
                                              row.tckt_status === 9 ||
                                              overdueReasign(row))
                                          ? "#FF4646"
                                          : row.tckt_status !== undefined &&
                                            row.tckt_status === 3
                                          ? "#707EAE"
                                          : row.tckt_status !== undefined &&
                                            overdueReasign(row)
                                          ? "#FF4646"
                                          : "#707EAE",
                                    }}
                                  >
                                    {row[column.id]}
                                  </div>
                                );
                                break;
                              case "tckt_status":
                                value = (
                                  <div
                                    style={{
                                      color: (() => {
                                        switch (row[column.id]) {
                                          case 3:
                                            return "#4caf50";
                                          case 2:
                                            return "#ff9800";
                                          case 1:
                                          case 8:
                                            return "#2196f3";
                                          case 4:
                                          case 6:
                                            return "#C7004C";
                                          case 5:
                                          case 9:
                                            return "#FF4646";
                                          case 7:
                                          case 10:
                                            return "#393091";
                                            case 11:
                                              return "#C7004C";
                                          default:
                                            return "black";
                                        }
                                      })(),
                                      backgroundColor: (() => {
                                        switch (row[column.id]) {
                                          case 3:
                                            return "#e8f5e9";
                                          case 2:
                                            return "#fff3e0";
                                          case 1:
                                          case 8:
                                            return "#e3f2fd";
                                          case 4:
                                          case 6:
                                            return "#C7004C1A";
                                          case 5:
                                          case 9:
                                            return "#FF46461A";
                                          case 7:
                                          case 10:
                                            return "#3930911A";
                                            case 11:
                                              return "#C7004C1A"
                                          default:
                                            return "transparent";
                                        }
                                      })(),
                                      fontWeight: "bold",
                                      textAlign: "center",
                                      padding: "2px 8px",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    {row["status_dec"]}
                                  </div>
                                );
                                break;
                              case "last_login_time":
                                value = <div>{formatDate(row[column.id])}</div>;
                                break;
                              case "refreshicon":
                                value = (
                                  <div
                                    style={{
                                      display:
                                        row["tckt_status"] === 7 ||
                                        row["tckt_status"] === 9 ||
                                        row["tckt_status"] === 10
                                          ? "block"
                                          : "none",
                                    }}
                                    onClick={() => {
                                      handleView(row, "refresh");
                                    }}
                                  >
                                    <RefreshIcon />
                                  </div>
                                );
                                break;
                              case props.statusName:
                                value = (
                                  <span style={{ cursor: "pointer" }}>
                                    <ActionButton
                                      buttonText={
                                        row[column.id] === "CANCEL"
                                          ? "CANCELLED"
                                          : row[column.id]
                                      }
                                      border="none"
                                    />
                                  </span>
                                );
                                break;
                              case "FName":
                                const firstName = row.FName || "";
                                const lastName = row.LName || "";
                                value = (
                                  <div>
                                    {firstName || lastName
                                      ? `${firstName} ${lastName}`.trim()
                                      : " "}
                                  </div>
                                );
                                break;

                              // case "created_on":
                              //   const createDate = row.created_on
                              //     ? new Date(
                              //         row.created_on
                              //       ).toLocaleDateString()
                              //     : "N/A";
                              //   value = <div>{createDate}</div>;
                              //   break;
                              case "user_status_id":
                                value =
                                  row.user_status_id === 1
                                    ? "Active"
                                    : "Inactive";
                                break;
                              case "menuIcon":
                                value = (
                                  <div>
                                    <MoreHorizIcon
                                      style={{
                                        marginTop: "3px",
                                        cursor: "pointer",
                                      }}
                                      onClick={(event) =>
                                        handleToggle(event, row.user_id)
                                      }
                                    />
                                    {show && menuOpenItemId === row.user_id && (
                                      <Menu
                                        elevation={2}
                                        anchorOrigin={{
                                          vertical: "bottom",
                                          horizontal: "right",
                                        }}
                                        transformOrigin={{
                                          vertical: "top",
                                          horizontal: "right",
                                        }}
                                        anchorEl={anchorEl} // Use current anchor
                                        open={menuOpenItemId === row.user_id}
                                        onClose={() => handleToggle(null)}
                                        sx={{
                                          "& .MuiMenuItem-root": {
                                            fontFamily: "'Poppins', sans-serif",
                                            alignItems: "center",
                                          },
                                        }}
                                      >
                                        <MenuItem
                                          onClick={() => handleEdit(row)}
                                        >
                                          Edit
                                        </MenuItem>
                                        <MenuItem
                                          onClick={() => handleDelete(row)}
                                        >
                                          {row.user_status_id === 1
                                            ? "Deactivate"
                                            : "Activate"}
                                        </MenuItem>
                                      </Menu>
                                    )}
                                  </div>
                                );
                                break;
                              default:
                                value = _.get(row, column.id, "");
                            }

                            return (
                              <StyledTableCell
                                key={column.id}
                                align={column.align}
                              >
                                {value}
                              </StyledTableCell>
                            );
                          })}
                        </StyledTableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
          {props.paginationRequired ? (
            <div>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={totalElements}
                rowsPerPage={paginationData.size}
                page={paginationData.pageNo}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
}

export default CommonTable; //React.memo(CommonTable)
